import { store } from '../state';
//import type { FilterValue, FilterOption, FiltersState } from './types';
import type { FilterValue, FilterOption } from './types';

// ============================================================================
// Расширение стейта приложения
// ============================================================================

// Добавляем в AppState (нужно будет прописать в state.ts):
// filters: FiltersState

// Добавляем в StateAction:
// | { type: 'SET_FILTER_VALUE'; payload: { filterId: string; value: FilterValue } }
// | { type: 'SET_FILTER_OPTIONS'; payload: { filterId: string; options: FilterOption[] } }
// | { type: 'SET_FILTER_LOADING'; payload: { filterId: string; loading: boolean } }
// | { type: 'RESET_FILTER'; payload: string }
// | { type: 'RESET_ALL_FILTERS' }

// ============================================================================
// Getters
// ============================================================================

export function getFilterValue(filterId: string): FilterValue {
  return store.getState().filters.values[filterId] ?? null;
}

export function getFilterOptions(filterId: string): FilterOption[] {
  return store.getState().filters.options[filterId] ?? [];
}

export function isFilterLoading(filterId: string): boolean {
  return store.getState().filters.loading[filterId] ?? false;
}

export function getAllFilterValues(): Record<string, FilterValue> {
  return store.getState().filters.values;
}

export function hasActiveFilters(): boolean {
  const values = store.getState().filters.values;
  return Object.values(values).some(v => {
    if (v === null) return false;
    if (Array.isArray(v)) return v.length > 0;
    return v !== '';
  });
}

// ============================================================================
// Actions
// ============================================================================

export function setFilterValue(filterId: string, value: FilterValue): void {
  store.dispatch({
    type: 'SET_FILTER_VALUE',
    payload: { filterId, value }
  });
}

export function setFilterOptions(filterId: string, options: FilterOption[]): void {
  store.dispatch({
    type: 'SET_FILTER_OPTIONS',
    payload: { filterId, options }
  });
}

export function setFilterLoading(filterId: string, loading: boolean): void {
  store.dispatch({
    type: 'SET_FILTER_LOADING',
    payload: { filterId, loading }
  });
}

export function resetFilter(filterId: string): void {
  store.dispatch({ type: 'RESET_FILTER', payload: filterId });
}

export function resetAllFilters(): void {
  store.dispatch({ type: 'RESET_ALL_FILTERS' });
}